import { Injectable } from '@angular/core';
import { DbEntityProvider } from './db-entity.provider';
import { DbDaoService, GetAllDataOptions } from '../db/db-dao.service';
import { UPDATES_TYPES } from '@shared/constants/updates-types.const';
import { Observable } from 'rxjs';
import { ProductCategory } from '@shared/classes/product-category.class';
import { Query } from '@paymash/capacitor-database-plugin';

@Injectable()
export class ProductCategoryProvider extends DbEntityProvider {
  constructor(dbDaoService: DbDaoService) {
    super(UPDATES_TYPES.ProductCategory.type, dbDaoService);
  }

  getByUuid(uuid: string): Observable<ProductCategory> {
    return <Observable<ProductCategory>>this.getEntityByUuid(uuid);
  }

  getList(): Observable<ProductCategory[]> {
    return <Observable<ProductCategory[]>>this.getEntitiesList();
  }

  getListByParams(queryParams: Query, options?: GetAllDataOptions): Observable<ProductCategory[]> {
    return <Observable<ProductCategory[]>>this.getEntitiesListByParams(queryParams, options).pipe(this.mapPipeTransformEntities());
  }
}
